import { createAsyncThunk } from '@reduxjs/toolkit';
import { authService } from 'services/AuthService';
import { secureApi, setupAxiosAuthInterceptors } from 'services/api';
import { mobileSettingsApi } from 'services/api/mobile-settings/queries';
import { userInfoApi } from 'services/api/user-info/queries';
import { userSettingsApi } from 'services/api/user-settings/queries';
import { FeatureName } from 'types/entities/MobileSettings';

export const initApp = createAsyncThunk(
  'appInit/init',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const settings = await dispatch(
        mobileSettingsApi.endpoints.getMobileSettings.initiate(),
      ).unwrap();

      const isSso = !settings?.disabledFeatureFlags?.includes(
        FeatureName.SINGLE_SIGN_ON,
      );

      authService.initialize(isSso, () =>
        dispatch(secureApi.util.resetApiState()),
      );

      setupAxiosAuthInterceptors(authService);

      await authService.handleLoginRedirect();

      if (authService.isAuthenticated()) {
        // To avoid a race condition when retrieving the token, we request it in advance. This can be optimized in the future.
        // Until we figure out why MSAL doesn’t cache the token, we’ll handle it manually.
        await authService.getAccessToken(); // Pre-fetch token

        const userAction = isSso
          ? userInfoApi.endpoints.getUserInfoV2.initiate()
          : userInfoApi.endpoints.getUserInfoV1.initiate();

        await dispatch(userAction);
        await dispatch(userSettingsApi.endpoints.getUserSettings.initiate());
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
